export default __webpack_public_path__ + "static/media/tg.370d00ee.svg";